module.exports = __webpack_public_path__ + "img/banner-1-mobile.ee88be90.png";